(()=>{
const run=CFG=>{
const host=document.getElementById(CFG.host),tpl=document.getElementById(CFG.tpl);
if(!host||!tpl||!host.attachShadow)return;
host.attachShadow({mode:"open"}).appendChild(tpl.content.cloneNode(true));

const COLOUR_HEX=[["Red","#d0312d"],["Orange","#f2731c"],["Neon Yellow","#e6fb2a"],["Yellow","#fbd225"],["Lime Green","#8cc63f"],["Neon Green","#3df56b"],["Dark Green","#17623a"],["Blue","#1f7fd8"],["Dark Blue","#1b2a78"],["Turqoise","#14b1c4"],["Purple","#7a2aa0"],["Dark Pink","#d61f69"],["Light Pink","#f6b9cf"],["Gold","#c99a2e"],["Beige","#e7d6b0"],["Pearl","#efece4"],["White","#fbfbfa"],["Silver","#bfc4c9"],["Black","#1b1b1c"]];
const _hex=Object.fromEntries(COLOUR_HEX);
const HAS_COL=CFG.variants.some(v=>v.option2);
/* colours set up in the product options app on this product (e.g. "Token Colour"), when there is one */
const BCPO_COL=(()=>{try{const d=window.bcpo_data,p=window.bcpo_product;if(!d||!p||p.handle!==CFG.handle)return null;return (d.virtual_options||[]).find(o=>o.type==="colors"&&o.values&&o.values.length)||null}catch(e){return null}})();
const COL_PROP=BCPO_COL?BCPO_COL.title:"Token colour";
const COLOURS=!HAS_COL&&BCPO_COL?BCPO_COL.values.map(v=>[v.key,"#"+String(v.value||"9aa0a6").replace("#","")]):(HAS_COL?[...new Set(CFG.variants.map(v=>v.option2))]:(CFG.colours&&CFG.colours.length?CFG.colours:COLOUR_HEX.map(c=>c[0]))).map(n=>[n,_hex[n]||"#9aa0a6"]);
const FLAT=["Turqoise","Beige","Pearl"]; // priced $0.55 on every print option in the store
const PRICE={one:.55,same:.60,diff:.65};
const OPTLABEL={one:"One Side Printing",same:"Two Sides Printing (Identical Designs)",diff:"Two Sides Printing (Non-Identical Designs)"};
const FONTS=[["Bebas Neue","'Bebas Neue'",400],["Anton","Anton",400],["Oswald","Oswald",600],["Montserrat","Montserrat",800],["Roboto Slab","'Roboto Slab'",700],["Pacifico","Pacifico",400],["Lobster","Lobster",400],["Public Sans","'Public Sans'",700]];
const TOKEN_R=14.5, RIM=2, FACE_R=TOKEN_R-RIM, PRINT_R=10.5, SAFE_R=PRINT_R, VIEW_MM=35;
const R=document.getElementById(CFG.host).shadowRoot;
const SITE_FONT=getComputedStyle(host).fontFamily||"sans-serif",LBL=CFG.label||"rgba(0,0,102,.75)",INK=CFG.ink||"#000066",MUTED=CFG.muted||"#4d4d8f";const $=s=>R.querySelector(s);const $$=s=>R.querySelectorAll(s);
const MIN=Math.max(1,+CFG.min||100),STEP=Math.max(1,+CFG.step||100);
const st={side:"front",opt:"one",colour:COLOURS.some(c=>c[0]==="Dark Blue")?"Dark Blue":COLOURS[0][0],qty:Math.max(MIN,500),guides:true,sel:null,sides:{front:[],back:[]},sample:true};
let uid=1;
const hex=n=>COLOURS.find(c=>c[0]===n)[1];
const lum=h=>{const n=parseInt(h.slice(1),16);return (0.299*(n>>16)+0.587*(n>>8&255)+0.114*(n&255))/255};
const defaultInk=()=>lum(hex(st.colour))>0.6?"#1b1b1c":"#ffffff";

/* ---------- side helpers ---------- */
function view(){ // objects to draw for current side + whether editable
  if(st.side==="back"&&st.opt==="same") return {objs:st.sides.front,locked:true,note:"Mirrors front"};
  if(st.side==="back"&&st.opt==="one") return {objs:[],locked:true,note:"Unprinted"};
  return {objs:st.sides[st.side],locked:false};
}
const selObj=()=>{const v=view();return v.locked?null:v.objs.find(o=>o.id===st.sel)||null};

/* ---------- canvas ---------- */
const cv=$("#cv"),ctx=cv.getContext("2d"),stage=$("#stage");
let S=10,CX=0,CY=0,DPR=1;
function resize(){
  DPR=window.devicePixelRatio||1;
  const w=stage.clientWidth;
  cv.width=Math.round(w*DPR);cv.height=Math.round(w*DPR);
  S=w/VIEW_MM;CX=w/2;CY=w/2;
  const cm=S*10; stage.style.setProperty("--cm",cm+"px"); stage.style.setProperty("--off",((CX-TOKEN_R*S)%cm)+"px");
  draw();
}
new ResizeObserver(resize).observe(stage);

function fontStr(o,px){const f=FONTS.find(f=>f[0]===o.font)||FONTS[0];return `${o.bold&&f[2]<700?"700 ":f[2]+" "}${px}px ${f[1]}, sans-serif`}

function drawObj(c,o,s,cx,cy,mark){
  c.save();
  if(o.type==="image"){
    const src=o.ko&&o.koCanvas?o.koCanvas:o.img; const w=o.w*s,h=w*o.ih/o.iw;
    c.translate(cx+o.x*s,cy+o.y*s);c.rotate(o.rot*Math.PI/180);
    c.drawImage(src,-w/2,-h/2,w,h);
    o._bb={w:o.w,h:o.w*o.ih/o.iw};
  }else if(o.curve==="none"){
    const px=o.size*s;c.font=fontStr(o,px);c.fillStyle=o.color;c.textAlign="center";c.textBaseline="middle";
    const lines=o.text.split("\n");const lh=px*1.1;
    c.translate(cx+o.x*s,cy+o.y*s);c.rotate(o.rot*Math.PI/180);
    let mw=0;lines.forEach((l,i)=>{c.fillText(l,0,(i-(lines.length-1)/2)*lh);mw=Math.max(mw,c.measureText(l).width)});
    o._bb={w:mw/s,h:lines.length*o.size*1.1};
  }else{
    const px=o.size*s,R=o.radius*s,sp=o.spacing*s;c.font=fontStr(o,px);c.fillStyle=o.color;c.textAlign="center";
    const ch=[...o.text];const ws=ch.map(k=>c.measureText(k).width+sp);const tot=ws.reduce((a,b)=>a+b,0)-sp;
    const rot=o.rot*Math.PI/180;
    if(o.curve==="top"){c.textBaseline="top";let a=-Math.PI/2-tot/(2*R)+rot;
      ch.forEach((k,i)=>{a+=(ws[i]-sp)/(2*R);c.save();c.translate(cx+R*Math.cos(a),cy+R*Math.sin(a));c.rotate(a+Math.PI/2);c.fillText(k,0,0);c.restore();a+=(ws[i]-sp)/(2*R)+sp/R});
    }else{c.textBaseline="alphabetic";let a=Math.PI/2+tot/(2*R)+rot;
      ch.forEach((k,i)=>{a-=(ws[i]-sp)/(2*R);c.save();c.translate(cx+R*Math.cos(a),cy+R*Math.sin(a));c.rotate(a-Math.PI/2);c.fillText(k,0,0);c.restore();a-=(ws[i]-sp)/(2*R)+sp/R});
    }
    o._span=tot/R/2;
  }
  c.restore();
  if(mark){
    c.save();c.strokeStyle="#ff8a3d";c.lineWidth=1.5;c.setLineDash([5,4]);
    if(o.type==="text"&&o.curve!=="none"){
      const mid=(o.curve==="top"?-Math.PI/2:Math.PI/2)+o.rot*Math.PI/180,R=o.radius*s,inR=(o.radius-o.size*.95)*s;
      c.beginPath();c.arc(cx,cy,R+2,mid-o._span-.04,mid+o._span+.04);c.arc(cx,cy,Math.max(2,inR-2),mid+o._span+.04,mid-o._span-.04,true);c.closePath();c.stroke();
    }else{
      c.translate(cx+o.x*s,cy+o.y*s);c.rotate(o.rot*Math.PI/180);
      const w=o._bb.w*s+8,h=o._bb.h*s+8;c.strokeRect(-w/2,-h/2,w,h);
    }
    c.restore();
  }
}

function drawToken(c,s,cx,cy,objs,{guides=false,sel=null,shadow=true,sheen=true}={}){
  const r=TOKEN_R*s,col=hex(st.colour);
  c.save();
  if(shadow){c.shadowColor="rgba(0,0,0,.4)";c.shadowBlur=s*2.2;c.shadowOffsetY=s*.6}
  c.beginPath();c.arc(cx,cy,r,0,Math.PI*2);c.fillStyle=col;c.fill();c.restore();
  const fr=FACE_R*s;
  if(sheen){
    // raised 2mm rim: lit top-left, shaded bottom-right
    c.save();c.beginPath();c.arc(cx,cy,r,0,Math.PI*2);c.arc(cx,cy,fr,0,Math.PI*2,true);c.clip();
    const rg=c.createLinearGradient(cx-r,cy-r,cx+r,cy+r);
    rg.addColorStop(0,"rgba(255,255,255,.30)");rg.addColorStop(.5,"rgba(255,255,255,.04)");rg.addColorStop(1,"rgba(0,0,0,.28)");
    c.fillStyle=rg;c.fillRect(cx-r,cy-r,r*2,r*2);c.restore();
    c.save();c.lineWidth=s*.3;c.strokeStyle="rgba(0,0,0,.25)";c.beginPath();c.arc(cx,cy,r-s*.15,0,Math.PI*2);c.stroke();
    // inner wall of the rim casting onto the recessed face
    c.beginPath();c.arc(cx,cy,fr,0,Math.PI*2);c.clip();
    const ig=c.createRadialGradient(cx+s*.35,cy+s*.45,fr*.86,cx,cy,fr);
    ig.addColorStop(0,"rgba(0,0,0,0)");ig.addColorStop(1,"rgba(0,0,0,.22)");c.fillStyle=ig;c.fillRect(cx-fr,cy-fr,fr*2,fr*2);c.restore();
  }
  c.save();c.beginPath();c.arc(cx,cy,PRINT_R*s,0,Math.PI*2);c.clip();
  objs.forEach(o=>drawObj(c,o,s,cx,cy,false));
  c.restore();
  if(sheen){
    c.save();c.beginPath();c.arc(cx,cy,r,0,Math.PI*2);c.clip();
    const g=c.createRadialGradient(cx-r*.45,cy-r*.55,r*.05,cx-r*.2,cy-r*.2,r*1.25);
    g.addColorStop(0,"rgba(255,255,255,.18)");g.addColorStop(.5,"rgba(255,255,255,.03)");g.addColorStop(1,"rgba(0,0,0,.08)");
    c.fillStyle=g;c.fillRect(cx-r,cy-r,r*2,r*2);c.restore();
  }
  if(sel) drawObj(c,sel,s,cx,cy,true);
  if(guides){
    c.save();c.setLineDash([4,4]);c.lineWidth=1;c.strokeStyle="rgba(255,255,255,.85)";
    c.beginPath();c.arc(cx,cy,SAFE_R*s,0,Math.PI*2);c.stroke();
    c.globalCompositeOperation="difference";c.strokeStyle="rgba(255,255,255,.35)";c.stroke();c.restore();
    // dimension line
    c.save();const y=cy-r-s*1.6;c.strokeStyle=LBL;c.fillStyle=LBL;c.lineWidth=1;
    c.beginPath();c.moveTo(cx-r,y);c.lineTo(cx+r,y);c.moveTo(cx-r,y-5);c.lineTo(cx-r,y+5);c.moveTo(cx+r,y-5);c.lineTo(cx+r,y+5);c.stroke();
    c.font=`500 ${Math.max(10,s*.75)}px ${SITE_FONT}`;c.textAlign="center";c.textBaseline="bottom";
    const lbl="Ø 29.00mm";const tw=c.measureText(lbl).width+10;
    c.fillStyle=getComputedStyle(stage).backgroundColor;c.fillRect(cx-tw/2,y-s*.9,tw,s*1.2);
    c.fillStyle=LBL;c.textBaseline="middle";c.fillText(lbl,cx,y-s*.3+s*.3);
    c.textAlign="left";c.fillStyle=LBL;c.fillText("print area Ø 21mm",cx+r*.35,cy+r+s*1.3);
    // rim callout on the right
    c.strokeStyle=LBL;c.beginPath();const ry=cy+s*.2;c.moveTo(cx+fr,ry);c.lineTo(cx+r,ry);c.moveTo(cx+fr,ry-4);c.lineTo(cx+fr,ry+4);c.moveTo(cx+r,ry-4);c.lineTo(cx+r,ry+4);c.moveTo(cx+r,ry);c.lineTo(cx+r+s*.9,ry);c.stroke();
    c.save();c.translate(cx+r+s*1.2,ry);c.rotate(Math.PI/2);c.textAlign="center";c.fillStyle=LBL;c.fillText("rim 2mm",0,0);c.restore();
    c.restore();
  }
}

function draw(){
  const w=cv.width/DPR;ctx.setTransform(DPR,0,0,DPR,0,0);ctx.clearRect(0,0,w,w);
  const v=view();
  drawToken(ctx,S,CX,CY,v.objs,{guides:st.guides,sel:v.locked?null:selObj()});
  if(v.locked){ctx.save();ctx.font=`600 ${Math.max(13,S*1)}px ${SITE_FONT}`;ctx.fillStyle=LBL;ctx.textAlign="center";
    ctx.fillText(v.note==="Unprinted"?"Back is unprinted with one-side printing":"Back prints the same as the front",CX,CY+TOKEN_R*S+S*2.6);ctx.restore()}
  $("#badge").textContent=`${st.side.toUpperCase()} · ${st.colour}${v.locked?" · "+v.note:""}`;
  scheduleSave();
}

/* ---------- objects ---------- */
function addImage(img,name,iw,ih,src){
  const v=view(); if(v.locked){ st.side="front"; syncSide(); }
  const o={id:uid++,type:"image",name,img,iw,ih,src,x:0,y:0,w:Math.min(14,14*iw/Math.max(iw,ih)),rot:0,ko:false,koCanvas:null,vector:/svg/i.test(name)};
  st.sides[st.side].push(o);select(o.id);
}
function addText(kind){
  const v=view(); if(v.locked){ st.side="front"; syncSide(); }
  const ink=defaultInk(),base={id:uid++,type:"text",font:"Bebas Neue",color:ink,bold:false,x:0,y:0,rot:0,spacing:.25};
  let o;
  if(kind==="top") o={...base,text:"YOUR CLUB NAME",curve:"top",radius:10.2,size:2.5,spacing:.2};
  else if(kind==="bottom") o={...base,text:"GOOD FOR ONE DRINK",curve:"bottom",radius:10.2,size:2.3,spacing:.2};
  else if(kind==="value") o={...base,text:"$5",curve:"none",size:8,font:"Anton",spacing:0};
  else o={...base,text:"YOUR TEXT",curve:"none",size:3.5,spacing:0};
  st.sides[st.side].push(o);select(o.id);
}
/* ---------- background removal ---------- */
function origPixels(o){ // cached raster copy of the original upload, max 2400px
  if(o._orig)return o._orig;
  const k=Math.min(o.vector?2400/Math.max(o.iw,o.ih):1,2400/Math.max(o.iw,o.ih));
  const c=document.createElement("canvas");c.width=Math.max(1,Math.round(o.iw*k));c.height=Math.max(1,Math.round(o.ih*k));
  const x=c.getContext("2d",{willReadFrequently:true});x.drawImage(o.img,0,0,c.width,c.height);
  o._orig={c,data:x.getImageData(0,0,c.width,c.height)};return o._orig;
}
function detectBg(o){ // look at the border: is it one plain colour?
  const {c,data}=origPixels(o),p=data.data,W=c.width,H=c.height;const pts=[];
  const step=Math.max(1,Math.floor((W+H)/400));
  for(let x=0;x<W;x+=step){pts.push(x,(H-1)*W+x)}for(let y=0;y<H;y+=step){pts.push(y*W,y*W+W-1)}
  let clear=0,sr=0,sg=0,sb=0,n=0;const opaque=[];
  pts.forEach(i=>{const a=p[i*4+3];if(a<30)clear++;else{opaque.push(i);sr+=p[i*4];sg+=p[i*4+1];sb+=p[i*4+2];n++}});
  if(clear/pts.length>.4)return {transparent:true};
  if(!n)return {transparent:true};
  const col=[sr/n,sg/n,sb/n].map(Math.round);
  const near=opaque.filter(i=>Math.hypot(p[i*4]-col[0],p[i*4+1]-col[1],p[i*4+2]-col[2])<40).length;
  return {transparent:false,color:col,uniform:near/opaque.length};
}
function processBg(o){
  if(!o.ko||!o.bg){o.koCanvas=null;o._thumb=null;return}
  const key=JSON.stringify(o.bg);if(o.koCanvas&&o._procKey===key)return;
  const {c:src,data}=origPixels(o),W=src.width,H=src.height,p=new Uint8ClampedArray(data.data);
  const [tr,tg,tb]=o.bg.color,d=o.bg.tol*2.6+4,soft=d+18;
  const dist=i=>Math.hypot(p[i]-tr,p[i+1]-tg,p[i+2]-tb);
  const N=W*H,mark=new Uint8Array(N);
  if(o.bg.edges){ // flood fill from the border so matching colours inside the artwork stay
    const q=new Int32Array(N);let h=0,t=0;
    const push=j=>{if(mark[j])return;const i=j*4;if(p[i+3]<30||dist(i)<soft){mark[j]=1;q[t++]=j}};
    for(let x=0;x<W;x++){push(x);push((H-1)*W+x)}for(let y=0;y<H;y++){push(y*W);push(y*W+W-1)}
    while(h<t){const j=q[h++],x=j%W,y=(j-x)/W;if(x>0)push(j-1);if(x<W-1)push(j+1);if(y>0)push(j-W);if(y<H-1)push(j+W)}
  }else mark.fill(1);
  for(let j=0;j<N;j++){if(!mark[j])continue;const i=j*4,e=dist(i);
    if(e<d)p[i+3]=0;else if(e<soft)p[i+3]=Math.round(p[i+3]*(e-d)/(soft-d))}
  const c=document.createElement("canvas");c.width=W;c.height=H;c.getContext("2d").putImageData(new ImageData(p,W,H),0,0);
  o.koCanvas=c;o._procKey=key;o._thumb=null;
  let gone=0;for(let j=0;j<N;j++)if(p[j*4+3]<128&&data.data[j*4+3]>=128)gone++;o._removed=Math.round(gone/N*100);
}
function knockWhite(o){ // older saved designs used a simple white knock-out
  if(!o.bg)o.bg={mode:"colour",color:[255,255,255],tol:12,edges:false};processBg(o);
}
const toHex=c=>"#"+c.map(v=>v.toString(16).padStart(2,"0")).join("");
const fromHex=h=>[1,3,5].map(i=>parseInt(h.slice(i,i+2),16));
let picking=null;
function dpi(o){ if(o.vector&&!o.ko) return Infinity; const px=o.ko&&o.koCanvas?o.koCanvas.width:o.iw; return Math.round(px/(o.w/25.4)); }
function dpiChip(o){const d=dpi(o);if(d===Infinity)return `<span class="chip good">Vector · sharp at any size</span>`;
  if(d>=300)return `<span class="chip good">${d} dpi · print-ready</span>`;if(d>=150)return `<span class="chip warn">${d} dpi · acceptable</span>`;return `<span class="chip bad">${d} dpi · may look blurry</span>`}

function select(id){st.sel=id;buildProps();buildLayers();draw()}
function remove(o){const a=st.sides[st.side];a.splice(a.indexOf(o),1);st.sel=null;buildProps();buildLayers();draw()}
function move(o,d){const a=st.sides[st.side],i=a.indexOf(o),j=i+d;if(j<0||j>=a.length)return;[a[i],a[j]]=[a[j],a[i]];buildLayers();draw()}

/* ---------- properties panel ---------- */
const props=$("#props");
function buildProps(){
  const o=selObj(),v=view();
  if(!o){
    props.innerHTML=`<div class="head"><span class="h3">${v.locked?(v.note==="Unprinted"?"Back side":"Back side"):"Nothing selected"}</span></div>
    <p class="note full" style="margin:0">${v.locked?(v.note==="Unprinted"?"Choose a two-sided printing option to design the back.":"Identical two-sided printing copies the front. Choose “Two sides, different” to design a separate back."):"Click an item on the token to edit it, or add artwork and text from the left."}</p>`;
    return;
  }
  if(o.type==="image"){
    props.innerHTML=`<div class="head"><span class="h3" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:60%">${esc(o.name)}</span><span id="p-dpi">${dpiChip(o)}</span></div>
    <div class="field"><label for="p-size">Width <span class="tabular" id="p-size-v"></span></label><input type="range" id="p-size" min="2" max="30" step="0.1"></div>
    <div class="field"><label for="p-rot">Rotate <span class="tabular" id="p-rot-v"></span></label><input type="range" id="p-rot" min="-180" max="180" step="1"></div>
    <div class="bgbox full">
      <div class="field"><label for="p-bgmode">Background</label>
        <select id="p-bgmode"><option value="off">Keep background</option><option value="auto">Remove plain background (automatic)</option><option value="colour">Remove a colour I choose</option></select></div>
      ${o.ko?`<div class="bgrow">
        <div class="field" style="flex:0 0 auto"><label for="p-bgcol">Colour</label><div class="row" style="align-items:center;flex-wrap:nowrap"><input type="color" id="p-bgcol" style="width:44px"><button class="btn small" id="p-pick" type="button">${picking===o?"Click the image…":"Pick from image"}</button></div></div>
        <div class="field" style="flex:1 1 160px"><label for="p-tol">Strength <span class="tabular" id="p-tol-v"></span></label><input type="range" id="p-tol" min="1" max="60" step="1"></div>
      </div>
      <label class="chk" style="color:var(--ink)"><input type="checkbox" id="p-edges"> Only remove around the outside (keeps the same colour inside the logo)</label>
      <p class="note" id="p-bgnote" style="margin:0"></p>`:`<p class="note" style="margin:0">Remove a solid background such as white or a coloured box, so the token colour shows around your logo.</p>`}
    </div>
    <div class="row full">${tools()}</div>`;
  }else{
    props.innerHTML=`<div class="head"><span class="h3">Text</span></div>
    <div class="field full"><label for="p-text">Wording</label>${o.curve==="none"?`<textarea id="p-text" rows="1"></textarea>`:`<input type="text" id="p-text">`}</div>
    <div class="field"><label for="p-font">Font</label><select id="p-font">${FONTS.map(f=>`<option style="font-family:${f[1]}">${f[0]}</option>`).join("")}</select></div>
    <div class="field"><label for="p-color">Ink colour</label><input type="color" id="p-color"></div>
    <div class="field"><label for="p-curve">Shape</label><select id="p-curve"><option value="none">Straight</option><option value="top">Curved along top</option><option value="bottom">Curved along bottom</option></select></div>
    <div class="field"><label for="p-size">Size <span class="tabular" id="p-size-v"></span></label><input type="range" id="p-size" min="1" max="12" step="0.1"></div>
    ${o.curve!=="none"?`<div class="field"><label for="p-radius">Gap to print edge <span class="tabular" id="p-radius-v"></span></label><input type="range" id="p-radius" min="4" max="10.5" step="0.1"></div>
    <div class="field"><label for="p-sp">Letter spacing <span class="tabular" id="p-sp-v"></span></label><input type="range" id="p-sp" min="0" max="1.5" step="0.05"></div>`:""}
    <div class="field"><label for="p-rot">${o.curve==="none"?"Rotate":"Slide around edge"} <span class="tabular" id="p-rot-v"></span></label><input type="range" id="p-rot" min="-180" max="180" step="1"></div>
    <div class="row full">${tools()}</div>`;
  }
  const on=(id,ev,fn)=>{const e=$(id);if(e)e.addEventListener(ev,fn)};
  on("#p-size","input",e=>{if(o.type==="image")o.w=+e.target.value;else o.size=+e.target.value;syncProps();draw()});
  on("#p-rot","input",e=>{o.rot=+e.target.value;syncProps();draw()});
  on("#p-bgmode","change",e=>{const m=e.target.value;picking=null;
    if(m==="off"){o.ko=false}
    else{o.ko=true;const prev=o.bg||{tol:22,edges:true};let col=prev.color;
      if(m==="auto"){const d=detectBg(o);col=d.transparent?[255,255,255]:d.color}
      o.bg={mode:m,color:col||[255,255,255],tol:prev.tol,edges:prev.edges}}
    processBg(o);buildProps();draw();buildLayers()});
  let raf=0;const reprocess=()=>{if(raf)return;raf=requestAnimationFrame(()=>{raf=0;processBg(o);syncProps();draw()})};
  on("#p-tol","input",e=>{o.bg.tol=+e.target.value;reprocess()});
  on("#p-tol","change",()=>buildLayers());
  on("#p-bgcol","input",e=>{o.bg={...o.bg,mode:"colour",color:fromHex(e.target.value)};$("#p-bgmode").value="colour";reprocess()});
  on("#p-edges","change",e=>{o.bg.edges=e.target.checked;processBg(o);syncProps();draw();buildLayers()});
  on("#p-pick","click",()=>{picking=picking===o?null:o;cv.style.cursor=picking?"crosshair":"default";$("#hint").textContent=picking?"Click your image on the token to pick the background colour":"Drag to move · scroll to resize · arrow keys nudge";$("#p-pick").textContent=picking?"Click the image…":"Pick from image"});
  on("#p-text","input",e=>{o.text=e.target.value||" ";draw();buildLayers()});
  on("#p-font","change",e=>{o.font=e.target.value;ensureFont(o).then(draw)});
  on("#p-color","input",e=>{o.color=e.target.value;draw()});
  on("#p-curve","change",e=>{o.curve=e.target.value;if(o.curve!=="none"){o.radius=o.radius||10.2;o.size=Math.min(o.size,2.8);o.text=o.text.replace(/\n/g," ");o.spacing=o.spacing||.25}o.rot=0;buildProps();draw()});
  on("#p-radius","input",e=>{o.radius=+e.target.value;syncProps();draw()});
  on("#p-sp","input",e=>{o.spacing=+e.target.value;syncProps();draw()});
  props.querySelectorAll("[data-act]").forEach(b=>b.addEventListener("click",()=>{
    const a=b.dataset.act;if(a==="del")remove(o);if(a==="up")move(o,1);if(a==="dn")move(o,-1);
    if(a==="center"){o.x=0;o.y=0;if(o.type==="text"&&o.curve!=="none")o.rot=0;draw()}
    if(a==="fit"&&o.type==="image"){const ar=o.ih/o.iw;o.w=Math.min(PRINT_R*2/Math.sqrt(1+ar*ar),PRINT_R*2);o.x=0;o.y=0;syncProps();draw()}
    if(a==="dup"){const c={...o,id:uid++,x:o.x+1.5,y:o.y+1.5};st.sides[st.side].push(c);select(c.id)}
  }));
  syncProps();
}
function tools(){const o=selObj();return `<button class="btn small" data-act="center">Centre</button>${o.type==="image"?`<button class="btn small" data-act="fit">Fit to print area</button>`:""}<button class="btn small" data-act="dup">Duplicate</button><button class="btn small" data-act="up" title="Bring forward">Forward</button><button class="btn small" data-act="dn" title="Send backward">Backward</button><button class="btn small" data-act="del" style="color:var(--bad)">Delete</button>`}
function syncProps(){
  const o=selObj();if(!o)return;const set=(id,v)=>{const e=$(id);if(e&&R.activeElement!==e)e.value=v};const txt=(id,v)=>{const e=$(id);if(e)e.textContent=v};
  if(o.type==="image"){set("#p-size",o.w);txt("#p-size-v",o.w.toFixed(1)+"mm");const d=$("#p-dpi");if(d)d.innerHTML=dpiChip(o);
    set("#p-bgmode",o.ko&&o.bg?o.bg.mode:"off");
    if(o.ko&&o.bg){set("#p-bgcol",toHex(o.bg.color));set("#p-tol",o.bg.tol);txt("#p-tol-v",o.bg.tol);const ed=$("#p-edges");if(ed)ed.checked=o.bg.edges;
      txt("#p-bgnote",o._removed!=null?`${o._removed}% of the image removed. Raise the strength if a halo remains; lower it if parts of your logo disappear.`:"")}}
  else{set("#p-text",o.text);set("#p-font",o.font);set("#p-color",o.color);set("#p-curve",o.curve);set("#p-size",o.size);txt("#p-size-v",o.size.toFixed(1)+"mm");
    set("#p-radius",o.radius);txt("#p-radius-v",(PRINT_R-o.radius).toFixed(1)+"mm");set("#p-sp",o.spacing);txt("#p-sp-v",o.spacing.toFixed(2)+"mm")}
  set("#p-rot",Math.round(o.rot));txt("#p-rot-v",Math.round(o.rot)+"°");
}
const esc=s=>String(s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));

/* ---------- layers ---------- */
function buildLayers(){
  const v=view(),ul=$("#layers");$("#layers-title").textContent=(st.side==="front"?"Front":"Back")+" layers";
  if(v.locked){ul.innerHTML=`<li class="empty" style="border:0;cursor:default">${v.note==="Unprinted"?"The back is not printed.":"The back copies the front."}</li>`;return}
  if(!v.objs.length){ul.innerHTML=`<li class="empty" style="border:0;cursor:default">No artwork yet. Upload a logo or add text.</li>`;return}
  ul.innerHTML=[...v.objs].reverse().map(o=>`<li data-id="${o.id}" class="${o.id===st.sel?"sel":""}" tabindex="0"><span class="thumb">${o.type==="image"?`<img alt="" src="${thumb(o)}">`:`<span style="font-family:${(FONTS.find(f=>f[0]===o.font)||FONTS[0])[1]}">Aa</span>`}</span><span class="nm">${esc(o.type==="image"?o.name:o.text)}</span><span class="note">${o.type==="image"?"Image":o.curve==="none"?"Text":"Curved"}</span></li>`).join("");
  ul.querySelectorAll("li[data-id]").forEach(li=>{const f=()=>select(+li.dataset.id);li.onclick=f;li.onkeydown=e=>{if(e.key==="Enter")f()}});
}
function thumb(o){if(o._thumb&&o._thumbKo===o.ko+(o._procKey||""))return o._thumb;const c=document.createElement("canvas");c.width=c.height=56;const x=c.getContext("2d");const src=o.ko&&o.koCanvas?o.koCanvas:o.img;const k=56/Math.max(o.iw,o.ih);x.drawImage(src,(56-o.iw*k)/2,(56-o.ih*k)/2,o.iw*k,o.ih*k);o._thumb=c.toDataURL();o._thumbKo=o.ko+(o._procKey||"");return o._thumb}

/* ---------- pointer ---------- */
function toMM(e){const r=cv.getBoundingClientRect();return {x:(e.clientX-r.left-CX)/S,y:(e.clientY-r.top-CY)/S}}
function hit(o,p){
  if(o.type==="text"&&o.curve!=="none"){
    const d=Math.hypot(p.x,p.y);if(d>o.radius+1||d<o.radius-o.size*1.1-1)return false;
    const mid=(o.curve==="top"?-Math.PI/2:Math.PI/2)+o.rot*Math.PI/180;let a=Math.atan2(p.y,p.x)-mid;a=Math.atan2(Math.sin(a),Math.cos(a));return Math.abs(a)<=(o._span||0)+.08;
  }
  if(!o._bb)return false;const t=-o.rot*Math.PI/180,dx=p.x-o.x,dy=p.y-o.y;const lx=dx*Math.cos(t)-dy*Math.sin(t),ly=dx*Math.sin(t)+dy*Math.cos(t);
  return Math.abs(lx)<=o._bb.w/2+.6&&Math.abs(ly)<=o._bb.h/2+.6;
}
let drag=null;
cv.addEventListener("pointerdown",e=>{
  try{cv.focus({preventScroll:true})}catch{}
  const v=view();if(v.locked)return;const p=toMM(e);
  if(picking){ // eyedropper: sample the original upload under the pointer
    const o=picking;const t=-o.rot*Math.PI/180,dx=p.x-o.x,dy=p.y-o.y;const lx=dx*Math.cos(t)-dy*Math.sin(t),ly=dx*Math.sin(t)+dy*Math.cos(t);
    const h=o.w*o.ih/o.iw,u=lx/o.w+.5,w2=ly/h+.5;
    if(u>=0&&u<1&&w2>=0&&w2<1){const {c,data}=origPixels(o);const i=(Math.floor(w2*c.height)*c.width+Math.floor(u*c.width))*4;
      o.ko=true;o.bg={mode:"colour",color:[data.data[i],data.data[i+1],data.data[i+2]],tol:o.bg?o.bg.tol:22,edges:o.bg?o.bg.edges:true};processBg(o)}
    picking=null;cv.style.cursor="default";$("#hint").textContent="Drag to move · scroll to resize · arrow keys nudge";buildProps();buildLayers();draw();return;
  }
  const o=[...v.objs].reverse().find(o=>hit(o,p));
  if(!o){if(st.sel!==null)select(null);return}
  if(o.id!==st.sel)select(o.id);
  cv.setPointerCapture(e.pointerId);
  drag={o,p0:p,x0:o.x,y0:o.y,rot0:o.rot,a0:Math.atan2(p.y,p.x)};cv.style.cursor="grabbing";
});
cv.addEventListener("pointermove",e=>{
  const p=toMM(e);
  if(!drag){const v=view();if(v.locked){cv.style.cursor="default";return}cv.style.cursor=[...v.objs].some(o=>hit(o,p))?"grab":"default";return}
  const o=drag.o;
  if(o.type==="text"&&o.curve!=="none"){o.rot=drag.rot0+(Math.atan2(p.y,p.x)-drag.a0)*180/Math.PI;o.rot=((o.rot+540)%360)-180}
  else{o.x=drag.x0+p.x-drag.p0.x;o.y=drag.y0+p.y-drag.p0.y;
    if(Math.abs(o.x)<.4)o.x=0; if(Math.abs(o.y)<.4)o.y=0;} // snap to centre
  syncProps();draw();
});
const end=()=>{if(drag){drag=null;cv.style.cursor="grab"}};
cv.addEventListener("pointerup",end);cv.addEventListener("pointercancel",end);
cv.addEventListener("wheel",e=>{const o=selObj();if(!o)return;e.preventDefault();const k=e.deltaY<0?1.04:1/1.04;
  if(o.type==="image")o.w=Math.max(2,Math.min(30,o.w*k));else o.size=Math.max(1,Math.min(12,o.size*k));syncProps();draw()},{passive:false});
document.addEventListener("keydown",e=>{if(!$("#overlay").hidden&&e.key==="Escape")closeReview()});
cv.tabIndex=0;
cv.addEventListener("keydown",e=>{
  const o=selObj();if(!o)return;
  const step=e.shiftKey?1:.25;const m={ArrowLeft:[-step,0],ArrowRight:[step,0],ArrowUp:[0,-step],ArrowDown:[0,step]}[e.key];
  if(m){e.preventDefault();if(o.type==="text"&&o.curve!=="none")o.rot+=m[0]*8;else{o.x+=m[0];o.y+=m[1]}syncProps();draw()}
  if(e.key==="Delete"||e.key==="Backspace"){e.preventDefault();remove(o)}
});

/* ---------- upload ---------- */
const drop=$("#drop"),file=$("#file"),msg=$("#upload-msg");
function handleFiles(list){
  [...list].forEach(f=>{
    if(f.type==="application/pdf"||/\.pdf$/i.test(f.name)){msg.className="note err";msg.textContent=`${f.name}: PDF files can't be placed on the token yet. Export it as PNG, JPG or SVG and upload again.`;return}
    if(!/image\/(png|jpe?g|svg\+xml)/.test(f.type)){msg.className="note err";msg.textContent=`${f.name}: use a PNG, JPG or SVG file.`;return}
    if(f.size>25e6){msg.className="note err";msg.textContent=`${f.name} is larger than 25 MB. Please export a smaller version.`;return}
    const r=new FileReader();r.onload=()=>{const img=new Image();img.onload=()=>{
      let iw=img.naturalWidth||1000,ih=img.naturalHeight||1000;if(/svg/.test(f.type)){img.width=iw;img.height=ih}
      clearSampleFlag();addImage(img,f.name,iw,ih,r.result);msg.className="note";
      const o=selObj(),d=detectBg(o);
      if(d.transparent) msg.textContent=`Added ${f.name}. It already has a transparent background. Drag it into place and check the print quality badge.`;
      else if(d.uniform>.8){o.ko=true;o.bg={mode:"auto",color:d.color,tol:22,edges:true};processBg(o);buildProps();draw();buildLayers();
        msg.textContent=`Added ${f.name}. We found a plain background and removed it. You can change this under Background below the token.`}
      else msg.textContent=`Added ${f.name}. Its background isn't one plain colour, so we've kept it. To remove part of it, choose “Remove a colour I choose” under Background and pick the colour.`;
    };img.onerror=()=>{msg.className="note err";msg.textContent=`${f.name} couldn't be read. Try saving it again as PNG.`};img.src=r.result};r.readAsDataURL(f);
  });
}
file.addEventListener("change",e=>{handleFiles(e.target.files);file.value=""});
["dragenter","dragover"].forEach(t=>drop.addEventListener(t,e=>{e.preventDefault();drop.classList.add("over")}));
["dragleave","drop"].forEach(t=>drop.addEventListener(t,e=>{e.preventDefault();drop.classList.remove("over")}));
drop.addEventListener("drop",e=>handleFiles(e.dataTransfer.files));
stage.addEventListener("dragover",e=>e.preventDefault());stage.addEventListener("drop",e=>{e.preventDefault();handleFiles(e.dataTransfer.files)});
$$(".preset").forEach(b=>b.addEventListener("click",()=>{clearSampleFlag();addText(b.dataset.preset);ensureFont(selObj()).then(draw)}));

/* ---------- tabs, side, options ---------- */
$$(".tab").forEach(t=>t.addEventListener("click",()=>{
  $$(".tab").forEach(x=>x.setAttribute("aria-selected",x===t));
  ["upload","text","layers"].forEach(p=>$("#pane-"+p).hidden=p!==t.dataset.pane);
}));
function syncSide(){$("#side-front").setAttribute("aria-pressed",st.side==="front");$("#side-back").setAttribute("aria-pressed",st.side==="back");
  $("#hint").hidden=view().locked;st.sel=null;buildProps();buildLayers();draw()}
$("#side-front").onclick=()=>{st.side="front";syncSide()};
$("#side-back").onclick=()=>{st.side="back";syncSide()};
$("#guides").onchange=e=>{st.guides=e.target.checked;draw()};
$$("input[name=opt]").forEach(r=>r.addEventListener("change",()=>{st.opt=r.value;
  if(st.opt==="diff"&&!st.sides.back.length&&st.sample){seedBack()}syncSide();price()}));
const sw=$("#swatches");
sw.innerHTML=COLOURS.map(([n,h],i)=>`<label class="sw" style="background:${h}" title="${n}"><input type="radio" name="col" id="col-${i}" value="${n}" ${n===st.colour?"checked":""} aria-label="${n}"></label>`).join("");
sw.addEventListener("change",e=>{const prevInk=defaultInk();st.colour=e.target.value;$("#cname").textContent=st.colour;
  const ink=defaultInk();if(ink!==prevInk){[...st.sides.front,...st.sides.back].forEach(o=>{if(o.type==="text"&&o.color===prevInk)o.color=ink});if(st.sampleImg)retintSample(ink)}
  buildProps();draw();price()});
const qty=$("#qty");
function setQty(n){n=Math.max(MIN,Math.round((+n||MIN)/STEP)*STEP);st.qty=n;qty.value=n;price()}
$("#q-up").onclick=()=>setQty(st.qty+STEP);$("#q-dn").onclick=()=>setQty(st.qty-STEP);qty.onchange=()=>setQty(qty.value);
/* bulk discount: read from the Quantity Breaks Now app when present, else these defaults (cents off each token) */
const DEFAULT_TIERS=[[1000,15],[2000,23],[4000,24],[6000,27],[8000,30],[10000,33],[25000,34],[50000,35]];
let TIERS=DEFAULT_TIERS;
function cfgTiers(){const b=(()=>{const v=variantFor("one");return v?v.price/100:PRICE.one})();
  const t=String(CFG.tiers||"").split(/[,\n]/).map(x=>x.split(":").map(y=>parseFloat(y.replace(/[^0-9.]/g,"")))).filter(a=>a[0]>0&&a[1]>=0).map(([q,p])=>[q,Math.round((b-p)*100)]).filter(a=>a[1]>0).sort((a,b)=>a[0]-b[0]);
  if(t.length){TIERS=t;return true}return false}
function loadTiers(){
  if(CFG.tiers)return cfgTiers();
  try{const gs=(window.qb&&window.qb.discount_groups)||[];
    for(const g of gs){
      let p="";try{p=JSON.stringify(g.products,(k,v)=>k==="discountGroup"?undefined:v)||""}catch(e){}
      const ids=CFG.variants.map(v=>String(v.product_id||"")).filter(Boolean);
      if(g.discountEnabled&&(p.includes(CFG.handle)||ids.some(id=>p.includes(id)))&&g.discountType==="fixed_amount"&&g.discountTierType==="MinimumLineItemQuantityTier"){
        const t=(g.discountTiers||[]).filter(t=>t.minLineItemQuantity&&t.discountAmount).map(t=>[t.minLineItemQuantity,t.discountAmount]).sort((a,b)=>a[0]-b[0]);
        if(t.length){TIERS=t;return true}
      }}
  }catch(e){}
  return false;
}
const tierOff=q=>{let a=0;TIERS.forEach(([m,c])=>{if(q>=m)a=c});return a/100};
function variantFor(opt=st.opt,col=st.colour){const ok=v=>!HAS_COL||v.option2===col,o=v=>(v.option1||"").toLowerCase();
  const exact=CFG.variants.find(v=>v.option1===OPTLABEL[opt]&&ok(v));if(exact)return exact;
  if(opt==="one")return CFG.variants.find(v=>/^one/.test(o(v))&&ok(v));
  if(opt==="diff")return CFG.variants.find(v=>/non-identical|different/.test(o(v))&&ok(v))||CFG.variants.find(v=>/^two/.test(o(v))&&ok(v));
  return CFG.variants.find(v=>/^two/.test(o(v))&&!/non-identical|different/.test(o(v))&&ok(v))}
function unit(opt=st.opt){const v=variantFor(opt);return v?v.price/100:(FLAT.includes(st.colour)?.55:PRICE[opt])}
function unitAt(q,opt=st.opt){return Math.max(0,Math.round((unit(opt)-tierOff(q))*100)/100)}
const money=n=>"$"+n.toLocaleString("en-AU",{minimumFractionDigits:2,maximumFractionDigits:2});
function renderTiers(){
  const el=$("#tiers");if(!el)return;const b=unit();
  el.innerHTML=`<table><thead><tr><th>Quantity</th><th>Price each</th></tr></thead><tbody>${[[MIN,0]].concat(TIERS.filter(t=>t[0]>MIN)).map(([m,c],i,a)=>{const on=st.qty>=m&&(i===a.length-1||st.qty<a[i+1][0]);return `<tr class="${on?"on":""}"><td>${m.toLocaleString("en-AU")}+</td><td>$${Math.max(0,b-c/100).toFixed(2)}</td></tr>`}).join("")}</tbody></table>`;
}
function price(){const base=unit(),u=unitAt(st.qty);["one","same","diff"].forEach(k=>{const e=$("#pr-"+k);if(e)e.textContent="$"+unitAt(st.qty,k).toFixed(2)});
  $("#total").textContent=money(u*st.qty);
  $("#breakdown").textContent=`${st.qty.toLocaleString("en-AU")} × $${u.toFixed(2)} AUD`+(u<base?` (bulk price, was $${base.toFixed(2)})`:"");
  const sv=$("#save");if(sv){const save=(base-u)*st.qty;sv.hidden=!(save>0);sv.textContent=save>0?`You save ${money(save)} with bulk pricing. Applied in your cart.`:""}
  const nx=TIERS.find(([m])=>m>st.qty),hn=$("#nexttier");if(hn){hn.hidden=!nx;if(nx)hn.textContent=`Order ${nx[0].toLocaleString("en-AU")}+ for $${Math.max(0,base-nx[1]/100).toFixed(2)} each.`}
  renderTiers();scheduleSave()}

/* ---------- export & review ---------- */
function exportCanvas(side,{px=900,proof=true}={}){
  const objs=side==="back"&&st.opt==="same"?st.sides.front:st.sides[side];
  const c=document.createElement("canvas");c.width=c.height=px;const x=c.getContext("2d");const s=px/(proof?31:PRINT_R*2);
  if(proof)drawToken(x,s,px/2,px/2,objs,{shadow:false});
  else{x.save();x.beginPath();x.arc(px/2,px/2,PRINT_R*s,0,Math.PI*2);x.clip();objs.forEach(o=>drawObj(x,o,s,px/2,px/2,false));x.restore()}
  return c;
}
function exportSide(side,opts){return exportCanvas(side,opts).toDataURL("image/png")}
function proofSheet(){
  const sides=st.opt==="one"?["front"]:["front","back"],sz=640,pad=40,lab=56;
  const c=document.createElement("canvas");c.width=sides.length*sz+(sides.length+1)*pad;c.height=sz+pad*2+lab+40;
  const x=c.getContext("2d");x.fillStyle="#ffffff";x.fillRect(0,0,c.width,c.height);
  sides.forEach((sd,i)=>{x.drawImage(exportCanvas(sd,{px:sz}),pad+i*(sz+pad),pad);
    x.fillStyle=INK;x.font="600 22px "+SITE_FONT;x.textAlign="center";
    x.fillText(sd.toUpperCase()+(sd==="back"&&st.opt==="same"?" (same as front)":""),pad+i*(sz+pad)+sz/2,pad+sz+34)});
  x.font="16px "+SITE_FONT;x.fillStyle=MUTED;x.textAlign="left";
  x.fillText(`${CFG.title} · ${st.colour} · ${OPTLABEL[st.opt]} · Qty ${st.qty} · ${orderData.designId}`,pad,c.height-28);
  return c;
}
function outside(o){
  if(o.type==="text"&&o.curve!=="none")return o.radius>SAFE_R+.05;
  if(!o._bb)return false;const t=o.rot*Math.PI/180;let m=0;
  [[-1,-1],[1,-1],[1,1],[-1,1]].forEach(([a,b])=>{const lx=a*o._bb.w/2,ly=b*o._bb.h/2;const X=o.x+lx*Math.cos(t)-ly*Math.sin(t),Y=o.y+lx*Math.sin(t)+ly*Math.cos(t);
    if(o.type==="image"){m=Math.max(m,Math.hypot(o.x,o.y)+Math.min(o._bb.w,o._bb.h)/2)}else m=Math.max(m,Math.hypot(X,Y))});
  return m>SAFE_R+.05;
}
let orderData=null;
function openReview(){
  const sides=st.opt==="one"?["front"]:st.opt==="same"?["front","back"]:["front","back"];
  $("#proofs").innerHTML=sides.map(sd=>`<div class="proof"><img alt="${sd} proof" src="${exportSide(sd)}"><span>${sd}${sd==="back"&&st.opt==="same"?" (same as front)":""}</span></div>`).join("");
  const u=unitAt(st.qty),base=unit();
  $("#sum").innerHTML=`<dt>Product</dt><dd>Round Plastic Token 29mm</dd><dt>Printing</dt><dd>${OPTLABEL[st.opt]}</dd><dt>Token colour</dt><dd>${st.colour}</dd><dt>Quantity</dt><dd>${st.qty.toLocaleString("en-AU")}</dd><dt>Unit price</dt><dd>$${u.toFixed(2)} AUD${u<base?` <span style="color:var(--muted)">(bulk price, was $${base.toFixed(2)})</span>`:""}</dd><dt>Total</dt><dd><b>${money(u*st.qty)} AUD</b></dd>`;
  const checks=[];const design=sides.filter(sd=>!(sd==="back"&&st.opt==="same"));
  design.forEach(sd=>{const objs=st.sides[sd];const L=sd[0].toUpperCase()+sd.slice(1);
    if(!objs.length)checks.push(["x",`${L} has no artwork. Add a logo or text, or our designers will contact you.`]);
    else checks.push(["ok",`${L}: ${objs.length} item${objs.length>1?"s":""} placed`]);
    objs.filter(o=>o.type==="image").forEach(o=>{const d=dpi(o);if(d<150)checks.push(["x",`${esc(o.name)} is ${d} dpi at this size and may print blurry. Upload a larger file or make it smaller.`]);else if(d<300)checks.push(["w",`${esc(o.name)} is ${d} dpi. It will print, but 300 dpi or more is sharper.`]);else checks.push(["ok",`${esc(o.name)} is print quality`])});
    objs.filter(outside).forEach(o=>checks.push(["w",`${o.type==="image"?esc(o.name):"“"+esc(o.text)+"”"} reaches past the 21mm print area on the ${sd}. Anything outside it won't print.`]));
    objs.filter(o=>o.type==="text"&&o.size<1.6).forEach(o=>checks.push(["w",`“${esc(o.text)}” is very small (${o.size.toFixed(1)}mm) and may be hard to read.`]));
    objs.filter(o=>o.type==="text"&&o.color.toLowerCase()===hex(st.colour).toLowerCase()).forEach(o=>checks.push(["x",`“${esc(o.text)}” is the same colour as the token and won't be visible.`]));
  });
  if(st.sample)checks.unshift(["w","This is still the sample design. Replace it with your own artwork before ordering."]);
  $("#checks").innerHTML=checks.map(([k,t])=>`<li><span class="i ${k==="ok"?"ok":k==="w"?"w":"x"}">${k==="ok"?"✓":"!"}</span><span>${t}</span></li>`).join("");
  $("#approve").checked=false;$("#addcart").disabled=true;$("#addcart").textContent="Add to cart";$("#cartmsg").hidden=true;
  orderData={designId:"TD-"+Date.now().toString(36).toUpperCase()};
  $("#overlay").hidden=false;$("#mclose").focus();
}
function closeReview(){$("#overlay").hidden=true;$("#review").focus()}
$("#review").onclick=openReview;$("#mclose").onclick=closeReview;
$("#overlay").addEventListener("click",e=>{if(e.target.id==="overlay")closeReview()});
$("#approve").onchange=e=>$("#addcart").disabled=!e.target.checked;
$("#addcart").onclick=()=>{
  const btn=$("#addcart"),msg=$("#cartmsg");
  const v=variantFor();
  if(!v){msg.hidden=false;msg.className="note err";msg.textContent="This colour and printing combination isn't available. Please choose another.";return}
  btn.disabled=true;btn.textContent="Adding to cart…";
  try{
    const f=document.getElementById(CFG.form);
    f.querySelectorAll("[data-td]").forEach(n=>n.remove());
    f.querySelector("[name=id]").value=v.id;f.querySelector("[name=quantity]").value=st.qty;
    const add=(name,val)=>{const i=document.createElement("input");i.type="hidden";i.name=`properties[${name}]`;i.value=val;i.dataset.td="1";f.appendChild(i)};
    const id=orderData.designId;
    add("Design ID",id);
    add("Artwork approved by customer","Yes");
    if(!HAS_COL)add(COL_PROP,st.colour);
    if(st.opt==="same")add("Back design","Same as front");
    if(st.opt==="diff")add("Back design","Different from front");
    const files=[];
    const fileOf=(d,name)=>{const [h,b]=d.split(",");const mime=(h.match(/:(.*?);/)||[,"image/png"])[1];const bin=atob(b);const u=new Uint8Array(bin.length);for(let i=0;i<bin.length;i++)u[i]=bin.charCodeAt(i);return new File([u],name,{type:mime})};
    files.push(["Front print file",fileOf(exportSide("front",{px:496,proof:false}),`${id}-front-print-21mm-600dpi.png`)]);
    if(st.opt==="diff")files.push(["Back print file",fileOf(exportSide("back",{px:496,proof:false}),`${id}-back-print-21mm-600dpi.png`)]);
    files.push(["Proof",fileOf(proofSheet().toDataURL("image/png"),`${id}-proof.png`)]);
    const used=st.opt==="diff"?[...st.sides.front,...st.sides.back]:st.sides.front;
    used.filter(o=>o.type==="image"&&o.src&&!o.sampleCup).slice(0,4).forEach((o,i)=>{try{files.push([`Original artwork ${i+1}`,fileOf(o.src,o.name)])}catch(e){}});
    let attached=true;
    files.forEach(([name,file])=>{
      const inp=document.createElement("input");inp.type="file";inp.name=`properties[${name}]`;inp.dataset.td="1";inp.hidden=true;
      try{const dt=new DataTransfer();dt.items.add(file);inp.files=dt.files}catch(e){attached=false}
      f.appendChild(inp);
    });
    if(!attached)add("Artwork note","Browser could not attach files. Customer to email artwork.");
    f.submit();
  }catch(e){
    btn.disabled=false;btn.textContent="Add to cart";msg.hidden=false;msg.className="note err";
    msg.textContent="Something went wrong adding this to your cart. Please try again, or email your artwork to info@combicraft.com.au.";
  }
};

/* ---------- sample ---------- */
function cupCanvas(ink){
  const c=document.createElement("canvas");c.width=c.height=800;const x=c.getContext("2d");x.fillStyle=ink;x.strokeStyle=ink;x.lineCap="round";x.lineJoin="round";
  // cup body
  x.beginPath();x.moveTo(190,330);x.lineTo(530,330);x.lineTo(500,600);x.quadraticCurveTo(495,640,455,640);x.lineTo(265,640);x.quadraticCurveTo(225,640,220,600);x.closePath();x.fill();
  // handle
  x.lineWidth=42;x.beginPath();x.arc(560,430,70,-Math.PI/2.2,Math.PI/2.2);x.stroke();
  // saucer
  x.beginPath();x.ellipse(360,680,240,34,0,0,Math.PI*2);x.fill();
  // steam
  x.lineWidth=30;[[290,0],[360,-20],[430,0]].forEach(([sx,dy])=>{x.beginPath();x.moveTo(sx,290+dy);x.bezierCurveTo(sx-40,240+dy,sx+40,190+dy,sx,130+dy);x.stroke()});
  return c;
}
function retintSample(ink){const o=st.sampleImg;if(!o||!st.sides.front.includes(o))return;o.img=cupCanvas(ink);o.cupInk=ink;o._thumb=null}
function seedSample(){
  const ink=defaultInk();
  const cup={id:uid++,type:"image",name:"sample-cup-logo.png",img:cupCanvas(ink),sampleCup:true,cupInk:ink,iw:800,ih:800,x:0,y:.4,w:9.6,rot:0,ko:false,koCanvas:null,vector:false};
  st.sampleImg=cup;
  st.sides.front=[cup,
    {id:uid++,type:"text",text:"THE CORNER CAFE",curve:"top",radius:10.3,size:2.6,font:"Bebas Neue",color:ink,bold:false,x:0,y:0,rot:0,spacing:.25},
    {id:uid++,type:"text",text:"★ ONE FREE COFFEE ★",curve:"bottom",radius:10.3,size:2.1,font:"Bebas Neue",color:ink,bold:false,x:0,y:0,rot:0,spacing:.2}];
}
function seedBack(){const ink=defaultInk();st.sides.back=[{id:uid++,type:"text",text:"THANK\nYOU",curve:"none",size:5.2,font:"Anton",color:ink,bold:false,x:0,y:0,rot:0,spacing:0}]}
function clearSampleFlag(){if(st.sample){st.sample=false;$("#samplebar").hidden=true}}
$("#clear-sample").onclick=()=>{st.sides.front=[];st.sides.back=[];st.sample=false;$("#samplebar").hidden=true;st.side="front";syncSide()};

function ensureFont(o){if(!o||o.type!=="text")return Promise.resolve();const f=FONTS.find(f=>f[0]===o.font)||FONTS[0];return document.fonts.load(`${f[2]} 40px ${f[1]}`).catch(()=>{})}

/* ---------- save on this device (IndexedDB) ---------- */
const KEY="draft:"+CFG.handle;
const DB={
  open(){return new Promise((res,rej)=>{try{const r=indexedDB.open("token-designer",1);r.onupgradeneeded=()=>r.result.createObjectStore("drafts");r.onsuccess=()=>res(r.result);r.onerror=()=>rej(r.error)}catch(e){rej(e)}})},
  async run(mode,fn){const db=await this.open();return new Promise((res,rej)=>{const tx=db.transaction("drafts",mode);const q=fn(tx.objectStore("drafts"));tx.oncomplete=()=>res(q&&q.result);tx.onerror=()=>rej(tx.error);tx.onabort=()=>rej(tx.error)})},
  get(k){return this.run("readonly",s=>s.get(k))},set(k,v){return this.run("readwrite",s=>s.put(v,k))},del(k){return this.run("readwrite",s=>s.delete(k))}
};
const SKIP=new Set(["img","koCanvas","_bb","_span","_thumb","_thumbKo","_orig","_procKey"]);
function serialize(){
  const strip=o=>Object.fromEntries(Object.entries(o).filter(([k])=>!SKIP.has(k)));
  return {v:1,opt:st.opt,colour:st.colour,qty:st.qty,sample:st.sample,sides:{front:st.sides.front.map(strip),back:st.sides.back.map(strip)}};
}
let ready=false,baseline="",lastSaved="",saveTimer=null,hasDraft=false;
const ss=$("#savestate");
const stamp=t=>new Date(t).toLocaleString("en-AU",{weekday:"short",hour:"numeric",minute:"2-digit"});
function showState(cls,txt){ss.className="savestate "+cls;ss.textContent=txt}
function scheduleSave(){if(!ready)return;clearTimeout(saveTimer);saveTimer=setTimeout(()=>saveDraft(false),700)}
async function saveDraft(force){
  const data=serialize();const j=JSON.stringify(data);
  if(!force&&(j===lastSaved||(!hasDraft&&j===baseline)))return;
  showState("busy","Saving…");
  try{const t=Date.now();await DB.set(KEY,{...data,savedAt:t});lastSaved=j;hasDraft=true;showState("ok","Saved on this device · "+stamp(t))}
  catch(e){showState("err","Couldn't save in this browser. Private browsing can block it.")}
}
async function restoreDraft(d){
  st.opt=d.opt;st.colour=d.colour;st.qty=d.qty;st.sample=!!d.sample;
  const load=o=>new Promise(res=>{
    if(o.type!=="image")return res(o);
    if(o.sampleCup){o.img=cupCanvas(o.cupInk||defaultInk());st.sampleImg=o;return res(o)}
    const img=new Image();img.onload=()=>{if(/svg/i.test(o.name)){img.width=o.iw;img.height=o.ih}o.img=img;if(o.ko){if(o.bg)processBg(o);else knockWhite(o)}res(o)};img.onerror=()=>res(null);img.src=o.src;
  });
  for(const side of ["front","back"]){const arr=(await Promise.all((d.sides[side]||[]).map(o=>load({...o})))).filter(Boolean);arr.forEach(o=>{o.id=uid++});st.sides[side]=arr}
  $("#opt-"+st.opt).checked=true;
  const sw2=[...$$("input[name=col]")].find(i=>i.value===st.colour);if(sw2)sw2.checked=true;
  $("#cname").textContent=st.colour;qty.value=st.qty;$("#samplebar").hidden=!st.sample;
}
$("#savenow").onclick=()=>saveDraft(true);
$("#start-new").onclick=async()=>{
  try{await DB.del(KEY)}catch{}
  hasDraft=false;lastSaved="";st.sides.front=[];st.sides.back=[];st.sample=false;st.side="front";
  $("#restorebar").hidden=true;$("#samplebar").hidden=true;baseline=JSON.stringify(serialize());
  showState("","Not saved yet");syncSide();price();
};

(async()=>{
  let d=null;try{d=await DB.get(KEY)}catch{}
  if(d&&d.v===1){await restoreDraft(d);hasDraft=true;lastSaved=JSON.stringify((({savedAt,...r})=>r)(d));
    $("#restoremsg").textContent=`Welcome back. We've reopened the design you saved on ${stamp(d.savedAt)}.`;$("#restorebar").hidden=false;showState("ok","Saved on this device · "+stamp(d.savedAt))}
  else if(CFG.sample) seedSample(); else {st.sample=false;$("#samplebar").hidden=true}
  // quantity chosen on the product page (?qty=), rounded up to the next step, never below the minimum
  const urlQty=parseInt(new URLSearchParams(location.search).get("qty"),10);
  st.qty=Math.max(MIN,Math.ceil((urlQty>0?urlQty:st.qty)/STEP)*STEP);qty.value=st.qty;
  loadTiers();price();buildProps();buildLayers();draw();
  baseline=JSON.stringify(serialize());ready=true;
  let tries=0;const iv=setInterval(()=>{if(loadTiers()||++tries>20){clearInterval(iv);price()}},500);
})();
Promise.all(FONTS.map(f=>document.fonts.load(`${f[2]} 40px ${f[1]}`).catch(()=>{})).concat([document.fonts.load("500 12px 'JetBrains Mono'").catch(()=>{})])).then(draw);
document.fonts.ready.then(draw);

};
Object.values(window.TD_CFG||{}).forEach(c=>{if(!c.started){c.started=true;run(c)}});
})();
